import React from 'react';

import ProductReservation from './_project/WebsiteComponents/Reservation/ProductReservation/ProductReservation';
import OrderOverview from './_project/WebsiteComponents/Store/OrderOverview/OrderOverview';
import ReservationOverview from './_project/WebsiteComponents/Reservation/ReservationOverview/ReservationOverview';
import ReservationConfirmed from './_project/WebsiteComponents/Reservation/ReservationOverview/ReservationConfirmed';
import CategoryReservation from './_project/WebsiteComponents/Reservation/CategoryReservation/CategoryReservation';
import FormBlock from './components/Form/FormBlock';
import BritgeComponentFormModal from './components/Form/BritgeComponentFormModal';
import { PartSlot } from './partSlot';
import { ProductStoreFilters, ProductStoreList, ProductForm, CartOverview, CheckoutPage, FeaturedList } from './WebsiteComponents/Store';

export const readJsonScriptData = (scriptId) => {
  if (!scriptId) return null;
  const script = document.getElementById(scriptId);
  if (!script) return null;
  try {
    return JSON.parse(script.textContent || 'null');
  } catch (error) {
    console.error(`Failed to parse bootstrap data from #${scriptId}`, error);
    return null;
  }
};

const parseDatasetBool = (value, defaultValue = true) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  const s = String(value).toLowerCase().trim();
  if (['true', '1', 'yes', 'y', 'on'].includes(s)) return true;
  if (['false', '0', 'no', 'n', 'off'].includes(s)) return false;
  return defaultValue;
};

const parseDatasetList = (value, fallback = []) => {
  if (!value) return fallback;
  const raw = String(value).trim();
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
  } catch (e) {
    // ignore
  }
  return raw.split(',').map(s => s.trim()).filter(Boolean);
};

const parseOverviewType = (value) => {
  const v = String(value || 'list').toLowerCase().trim();
  return v === 'grid' ? 'grid' : 'list';
};

const STORE_FIELDS = ['name', 'price', 'price_discount', 'variants', 'add_to_cart'];

export const componentRegistry = {
  'product-reservation': {
    Component: ProductReservation,
    mapProps: () => ({}),
  },
  'category-reservation': {
    Component: CategoryReservation,
    mapProps: (el) => ({
      category_id: el.dataset.categoryId,
      overviewType: parseOverviewType(el.dataset.overviewType),
    }),
  },
  'featured-products': {
    Component: FeaturedList,
    mapProps: (el) => ({
      bindingId: el.getAttribute('data-umr-data-id') || '',
      binding: el.getAttribute('data-umr-data'),
      typeHint: 'product.Product',
      flexWrap: parseDatasetBool(el.dataset.productListFlexWrap, true),
      fields: parseDatasetList(el.dataset.productListFields, STORE_FIELDS),
      cardComponent: el.dataset.umrCardComponent || 'ProductCard',
    }),
  },
  'featured-product-groups': {
    Component: FeaturedList,
    mapProps: (el) => ({
      bindingId: el.getAttribute('data-umr-data-id') || '',
      binding: el.getAttribute('data-umr-data'),
      typeHint: 'product.ProductGroup',
      flexWrap: parseDatasetBool(el.dataset.productListFlexWrap, true),
    }),
  },
  'product-store': {
    Component: ProductStoreList,
    mapProps: (el) => ({
      initialData: readJsonScriptData(el.dataset.initialDataId),
      flexWrap: parseDatasetBool(el.dataset.productListFlexWrap, true),
      width: el.dataset.productListWidth || '25%',
      fields: parseDatasetList(el.dataset.productListFields, STORE_FIELDS),
      cardComponent: el.dataset.umrCardComponent || 'ProductCard',
    }),
  },
  'product-store-filter': {
    Component: ProductStoreFilters,
    mapProps: (el) => ({
      initialData: readJsonScriptData(el.dataset.initialDataId),
    }),
  },
  'product-detail': {
    Component: (props) => React.createElement(
      PartSlot,
      { id: props.formComponent, props },
      React.createElement(ProductForm, props),
    ),
    mapProps: (el) => ({
      productId: el.dataset.productId,
      initialProduct: readJsonScriptData(el.dataset.initialDataId),
      locationSearch: window.location.search,
      formComponent: el.dataset.umrFormComponent || 'ProductForm',
    }),
  },
  cart: {
    Component: CartOverview,
    mapProps: () => ({
      initialCart: readJsonScriptData('page-context'),
    }),
  },
  checkout: {
    Component: CheckoutPage,
    mapProps: (el) => ({
      formUrl: el.dataset.formUrl || '/rest/salesorder/checkout/',
    }),
  },
  'order-overview': {
    Component: OrderOverview,
    mapProps: () => ({}),
  },
  'reservation-overview': {
    Component: ReservationOverview,
    mapProps: (el) => ({
      initialReservation: readJsonScriptData(el.dataset.initialDataId || 'reservation-data'),
      initialOptionsForm: readJsonScriptData(el.dataset.optionsFormId || 'reservation-options-form-data'),
    }),
  },
  'reservation-confirmed': {
    Component: ReservationConfirmed,
    mapProps: (el) => ({
      initialReservation: readJsonScriptData(el.dataset.initialDataId || 'reservation-data'),
    }),
  },
  form: {
    Component: FormBlock,
    mapProps: (el) => ({
      url: el.dataset.url,
      initialData: readJsonScriptData(el.dataset.initialDataId),
    }),
  },
  'form-modal': {
    Component: BritgeComponentFormModal,
    mapProps: (el) => ({
      url: el.dataset.url,
      text: el.dataset.text,
      navigateUrl: el.dataset.navigateUrl,
      initialData: readJsonScriptData(el.dataset.initialDataId),
    }),
  },
};
